export class ProductoTipo{
	constructor(
		public idProductoTipo:number,
		public descripcion:string,
		public idRazonSocial : number
	){}
}